import { defineComponent } from "bitecs";

export const TagPetComponent = defineComponent({});
